type DefaultScrollHeight = 0 | 125;

export function isMobileDocs(): boolean {
  return window.innerWidth <= 768;
}

export function initDocsScroll(topBannerHeight: DefaultScrollHeight = 125): void {
  const isBelowTopBannerHeight: boolean = window.scrollY > topBannerHeight;

  if (isBelowTopBannerHeight && !isMobileDocs()) {
    setTimeout(() => {
      window.scrollTo({ top: topBannerHeight, behavior: 'smooth' });
    }, 10);
  }
}
